import axios from 'axios';
import { LoginPageIssueReportRequest, LoginPageIssueReportResponse } from '../models/IssueReport';
import { LOGIN_PAGE_REPORT_ISSUE } from '../constants/routes';

class IssueReportService {
  /**
   * Report an issue from the login page - unauthenticated endpoint
   * @param issue Issue report data
   * @returns Response from API
   */
  public reportLoginPageIssue = async (issue: LoginPageIssueReportRequest) => {
    try {
      const response = await axios.post<LoginPageIssueReportResponse>(LOGIN_PAGE_REPORT_ISSUE, issue, {
        headers: {
          'Content-Type': 'application/json'
        },
      });
      
      return response;
    } catch (error: any) {
      return error.response || error;
    }
  }
}

export default new IssueReportService();
